<template>
  <div>
    <p class="ruler-type-heading">{{ rulerType() }}</p>
    <div
      :style="
        `background:${local_ruler.styles.bg_color}; border: 2px solid ${local_ruler.styles.border_color} ;height: ${local_ruler.styles.height}px; width: ${local_ruler.styles.width}px`
      "
      class="ruler-rectangle"
      v-if="numbering().length > 0"
    >
    <div :style="`color: ${local_ruler.styles.font_color};position: relative ;width: 55%;border-bottom: 2px solid ${local_ruler.styles.font_color}`"> 
       <!-- number -->
        <div :style="`position: absolute;right: -20px; bottom: -12px`">
          {{ last_dummy_number}}
        </div>
    </div>
      <div
        v-for="(big_line, big_line_index) in numbering()"
        :key="`RULERLINE${big_line_index}`"
        :style="
          `height: ${heightBetweenBigLines()}px;width: 55%;border-bottom: 2px solid ${
            local_ruler.styles.font_color
          };color: ${local_ruler.styles.font_color}`
        "
        class="ruler-big-line"
      >
        <!-- numbers -->
        <div :style="`position: absolute;right: -20px; bottom: -12px`">
          {{ big_line }}
        </div>
        <!-- small-lines -->
        <div
          v-for="(small_line, small_line_index) in local_ruler.num_lines"
          :style="
            `height: ${heightBetweenSmallLines()}px;width: ${getSmallMidLineHeight(
              small_line_index
            )}%; border-bottom: 2px solid ${local_ruler.styles.font_color}`
          "
          :key="`SMALLLINE${small_line_index}`"
          class="ruler-small-line"
        ></div>
        <div
          class="dummy-line"
          :style="`height: ${heightBetweenSmallLines()}px;width: 100%`"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vertical-ruler",
  props: {
    ruler: {
      type: Object,
    },
  },
  data() {
    return {
      local_ruler: this.ruler,
      last_dummy_number: null
    };
  },
  methods: {
    rulerType() {
      let type = this.local_ruler.type;
      let ruler_type = { C: "In Centimeters", I: "In Inch" };

      if (type) {
        return ruler_type[type];
      } else {
        return "";
      }
    },
    numbering() {
      let start = this.local_ruler.start;
      let end = this.local_ruler.end;
      let stepsize = this.local_ruler.stepsize;

      let nums = [];

      for (let i = start; i <= end; i += stepsize) {
        nums.push(i);
      }

      this.last_dummy_number = nums[nums.length -1]

      nums = nums.slice(0, nums.length -1)

      return nums.reverse();
    },
    heightBetweenBigLines() {
      let padding = 24 // padding inside ruler
      let nums = this.numbering();
      let height = this.local_ruler.styles.height - padding ;

      return height / nums.length;
    },
    getSmallMidLineHeight(index) {
      let half_num_lines = this.local_ruler.num_lines / 2;

      if (index == Math.floor(half_num_lines)) {
        return 65;
      } else return 40;
    },
    heightBetweenSmallLines() {
      let num_lines = this.local_ruler.num_lines;
      let sec_width = this.heightBetweenBigLines();

      return sec_width / num_lines + 1;
    },
  },
};
</script>

<style scoped>
.ruler-type-heading {
  font-weight: 600;
}
.ruler-rectangle {
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding: 10px 0px;
}
.ruler-big-line {
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.ruler-small-line {
  position: relative;
}
.dummy-line {
  position: relative;
}
</style>
